export const DROPDOWN_KEY = {
	FILTER_IN: 'filterIn',
	FILTER_OUT: 'filterOut',
	GROUP_BY: 'groupBy',
};
